import React from 'react';
import { Route } from 'react-router-dom';
import { AuthorisationConsumer } from '@shootsta/common-react';
import NotFoundWithSentry from '../common/components/NotFoundWithSentry';

export default ({
  path,
  permission,
  component,
  exact
}: {
  path: string;
  permission: string;
  component: any;
  exact?: boolean;
}) => (
  <AuthorisationConsumer>
    {({ selectedOrganisation: { permissions: orgPermissions } = {} }) => {
      if (!orgPermissions.includes(permission)) {
        return <NotFoundWithSentry />;
      }

      return <Route path={path} component={component} exact={exact} />;
    }}
  </AuthorisationConsumer>
);
